module.exports = __webpack_public_path__ + "img/02-egg-1-base.161eed41.svg";